module.exports = __webpack_public_path__ + "img/icon1.01284d9d.png";